/* GCA cart recommendations 2026-07-03
   Renders complementary-product cards into the cart page and cart drawer.
   Client-side so results are always fresh and follow cart changes live. */
(function () {
  var COMPLEMENTS = [
    { match: /wrestling shoe/i, handles: ['headgear', 'chin-straps', 'knee-pads', 'wrestlingsinglets', 'wrestling-backpacks', 'wrestling-accessories'] },
    { match: /headgear/i, handles: ['chin-straps', 'wrestling-shoes', 'knee-pads', 'wrestling-backpacks', 'wrestling-accessories'] },
    { match: /singlet/i, handles: ['wrestling-shoes', 'headgear', 'knee-pads', 'wrestling-backpacks'] },
    { match: /knee ?pad/i, handles: ['headgear', 'wrestling-shoes', 'chin-straps', 'wrestlingsinglets'] },
    { match: /bowling ball/i, handles: ['bowling-bags', 'bowling-shoes', 'bowling-accessories'] },
    { match: /bowling shoe/i, handles: ['bowling-shoe-accessories', 'bowling-bags', 'bowling-accessories'] }
  ];
  var LIMIT = 4;
  var busy = false;
  var cache = {};

  function money(price) {
    var n = parseFloat(price);
    return isNaN(n) ? '' : '$' + n.toFixed(2);
  }

  function imgUrl(src, width) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s || '';
    return d.innerHTML;
  }

  function removeAll() {
    document.querySelectorAll('.gca-cart-recommendations').forEach(function (e) { e.remove(); });
  }

  async function collectionProducts(handle) {
    if (cache[handle]) return cache[handle];
    try {
      var res = await fetch('/collections/' + handle + '/products.json?limit=8');
      var data = await res.json();
      cache[handle] = data.products || [];
    } catch (e) {
      cache[handle] = [];
    }
    return cache[handle];
  }

  async function build() {
    if (busy) return;
    busy = true;
    try {
      var cart = await (await fetch('/cart.js')).json();
      var forms = document.querySelectorAll('.js-cart-form');
      if (!cart.items.length || !forms.length) { removeAll(); return; }

      var firstTitle = cart.items[0].product_title || cart.items[0].title || '';
      var entry = null;
      for (var c = 0; c < COMPLEMENTS.length; c++) {
        if (COMPLEMENTS[c].match.test(firstTitle)) { entry = COMPLEMENTS[c]; break; }
      }
      if (!entry) { removeAll(); return; }

      var inCart = {};
      cart.items.forEach(function (i) { inCart[i.product_id] = true; });

      var picks = [];
      for (var h = 0; h < entry.handles.length && picks.length < LIMIT; h++) {
        var products = await collectionProducts(entry.handles[h]);
        for (var p = 0; p < products.length; p++) {
          var prod = products[p];
          if (inCart[prod.id]) continue;
          if (picks.some(function (x) { return x.id === prod.id; })) continue;
          if (!prod.variants || !prod.variants.some(function (v) { return v.available; })) continue;
          picks.push(prod);
          break;
        }
      }
      if (!picks.length) { removeAll(); return; }

      var html = '<p class="gca-cart-recommendations__heading">Complete your setup</p>' +
        '<div class="gca-cart-recommendations__row">' +
        picks.map(function (prod) {
          var img = prod.images && prod.images[0] ? prod.images[0].src : '';
          var price = prod.variants && prod.variants[0] ? money(prod.variants[0].price) : '';
          return '<a class="gca-cart-recommendation" href="/products/' + prod.handle + '">' +
            '<span class="gca-cart-recommendation__image">' +
            (img ? '<img src="' + imgUrl(img, 320) + '" alt="' + esc(prod.title) + '" loading="lazy" width="140" height="140">' : '') +
            '</span>' +
            '<span class="gca-cart-recommendation__info">' +
            '<span class="gca-cart-recommendation__title">' + esc(prod.title) + '</span>' +
            '<span class="gca-cart-recommendation__price">' + price + '</span>' +
            '</span></a>';
        }).join('') +
        '</div>';

      forms.forEach(function (form) {
        var el = form.querySelector('.gca-cart-recommendations');
        if (!el) {
          el = document.createElement('div');
          el.className = 'gca-cart-recommendations span-12 auto';
          var items = form.querySelector('.ajax-cart__cart-items');
          if (items) {
            items.insertAdjacentElement('afterend', el);
          } else {
            form.appendChild(el);
          }
        }
        el.innerHTML = html;
      });
    } catch (e) {
      /* never break the cart over recommendations */
    } finally {
      busy = false;
    }
  }

  var deb;
  function schedule() {
    clearTimeout(deb);
    deb = setTimeout(build, 350);
  }

  function init() {
    /* native title tooltips on nav labels look glitchy; the label is already visible */
    document.querySelectorAll('.navigation [title]').forEach(function (e) { e.removeAttribute('title'); });
    schedule();
    document.querySelectorAll('.js-ajax-cart-content').forEach(function (container) {
      new MutationObserver(schedule).observe(container, { childList: true });
    });
    document.addEventListener('cart:updated', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
